import BigNumber from "./BigNumber"

export interface Props {
  number?: number
}

export interface ComponentProps extends Props {}

export default BigNumber
